<template>
  <div class="gt-product-picker-panel">
    <div v-if="plugins.length">
      <el-form :label-width="labelWidth" :size="formSize" :disabled="disabled">
        <el-form-item :label="$t('Root.Picker.Select')" v-if="!hiddenSelect">
          <el-radio-group v-model="activePlugin">
            <el-radio v-for="item in plugins" :key="item.id" :label="item.id">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <slot></slot>
    </div>
    <div
      v-show="showRequiredErrorMsg"
      class="el-form-item__error gt-product-picker-panel--reset"
      :style="{
        'padding-left': labelWidth
      }"
    >
      {{ $t("Root.Picker.Please_select_at_least_options") }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductPickerPanel",

  provide() {
    return { master: this };
  },

  props: {
    labelWidth: {
      type: String,
      default: "180px"
    },

    formSize: {
      type: String,
      default: "small"
    },

    defaultActive: {
      type: [String, Number],
      required: true
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    },

    hiddenSelect: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  watch: {
    defaultActive: {
      handler: "setDefaultActivePlugin",
      immediate: true
    }
  },

  data() {
    return {
      activePlugin: "",

      plugins: [],

      showRequiredErrorMsg: false
    };
  },

  methods: {
    // showRequiredErrorMsg
    toggleRequiredErrorMsgVisible(visible = false) {
      this.showRequiredErrorMsg = visible;
    },

    // 设置默认激活的plugin
    setDefaultActivePlugin(id) {
      this.activePlugin = id;
    },

    // 注册plugin
    registerPlugin(data) {
      const { label, id, validator } = data;

      // 防止重复注册
      if (this.plugins.find(item => item.id === id)) return;

      this.plugins.push({ label, id, validator });
    },

    // 注销plugins
    unregisterPlugin(data) {
      const { id: beRemoveId } = data;
      const index = this.plugins.findIndex(({ id }) => id == beRemoveId);

      if (index < 0) return;

      this.plugins.splice(index, 1);
    },

    // 触发表单验证
    async submit() {
      const { activePlugin } = this;

      this.toggleRequiredErrorMsgVisible();

      let plugin = this.plugins.find(({ id }) => id === activePlugin);

      if (plugin && plugin.validator) {
        let data = await plugin.validator();
        let res = {
          active: activePlugin,
          data
        };

        console.log(JSON.stringify(res, null, 4));

        return res;
      }
    }
  }
};
</script>

<style lang="scss">
.gt-product-picker-panel {
  background: #fff;
  position: relative;

  .el-form-item {
    margin-bottom: 16px;
  }

  .el-form-item__label,
  .el-form-item {
    line-height: 32px;
  }

  .gt-common--reset {
    width: 100%;
  }

  &--reset {
    &.el-form-item__error {
      margin-top: 10px;
    }
  }
}
</style>
